<template>
  <div class="gadget topic-card-container">
    <EachTopicCard
      v-for="(topic, index) in topics"
      :topic="topic"
      :type="type"
      class="topic-card"
      :key="index"
    ></EachTopicCard>
    <div v-if="fetching" class="text-center">
      <div class="loading-content">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div
      v-if="this.loadMoreMessage == '已加载全部数据'"
      class="text-center"
      width="100%"
    >
      {{ this.loadMoreMessage }}
    </div>
    <el-button
      v-else
      type="default"
      style="width: 100%;"
      v-on:click="fetchTopics"
      >{{ this.loadMoreMessage }}</el-button
    >
  </div>
</template>

<script>
import { mapState } from "vuex";
import EachTopicCardComponent from "./EachTopicCardComponent";

export default {
  props: {
    queryParams: {
      type: Object,
      required: false
    },
    type: {
      type: String,
    },
  },
  data: function() {
    return {
      fetching: false,
      topics: [],
      currentPage: 1,
      totalPage: 2,
      loadMoreMessage: "",
      loadedLatestpage: 0
    };
  },
  computed: {
    ...mapState(["topicsUrl", "currentCategoryId"]),
    queryObject: function() {
      return { ...this.queryParams, ...{ page: this.currentPage } };
    }
  },
  mounted: function() {
    this.fetchTopics();
    window.addEventListener("scroll", this.scroll);
  },
  components: {
    EachTopicCard: EachTopicCardComponent
  },
  filters: {
    truncate(value) {
      if (value.length > 50) {
        value = value.substring(0, 47) + "...";
      }

      return value;
    }
  },
  methods: {
    goToTopic: function(topic) {
      let url =
        "/topics/" + topic.id + (topic.slug === null ? "" : "/" + topic.slug);
      window.open(url, "_blank");
    },
    encodedQueryString: function(url) {
      const ret = [];
      for (let d in this.queryObject) {
        ret.push(
          encodeURIComponent(d) + "=" + encodeURIComponent(this.queryObject[d])
        );
      }

      var connectSymbol = url.indexOf("?") === -1 ? "?" : "&";
      return url + (ret.length === 0 ? "" : connectSymbol + ret.join("&"));
    },
    fetchTopics: function() {
      if (this.currentPage > this.totalPage) {
        this.loadMoreMessage = "已加载全部数据";
        return;
      }
      if (this.currentPage <= this.loadedLatestPage) {
        return;
      }
      this.loadedLatestPage = this.currentPage;
      var url = this.topicsUrl;
      if (url === "") return;
      // this.topicsUrl ||
      // (window.location.pathname === "/"
      //   ? "/api/topics"
      //   : "/api" + window.location.pathname);
      this.loadMoreMessage = "";
      this.fetching = true;
      this.$axios.get(this.encodedQueryString(url)).then(response => {
        let topics = response.data.data;
        if (!topics.length) {
          this.loadMoreMessage = "暂无数据";
        }
        this.fetching = false;
        for (var topic in topics) {
          this.topics.push(topics[topic]);
        }
        this.totalPage = response.data.meta.pagination.total_pages;
        this.currentPage++;
        if (this.currentPage > this.totalPage) {
          this.loadMoreMessage = "已加载全部数据";
        } else {
          this.loadMoreMessage = "点击或向下滚动加载更多";
        }
      });
    },
    scroll() {
      let bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight ===
        document.documentElement.offsetHeight;
      if (bottomOfWindow) {
        this.fetchTopics();
      }
    }
  }
};
</script>
<style scoped>
.topic-card-container {
  margin-left: -10px;
}
.topic-card + .topic-card {
  margin-left: 10px;
}
.topic-card {
  margin-left: 10px;
  width: 100%;
  height: 100%;
  display: inline-flex;
}
.loading-content {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}

.loading-content div {
  display: inline-block;
  position: absolute;
  left: 6px;
  width: 13px;
  background: gray;
  animation: loading-content 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}

.loading-content div:nth-child(1) {
  left: 6px;
  animation-delay: -0.24s;
}

.loading-content div:nth-child(2) {
  left: 26px;
  animation-delay: -0.12s;
}

.loading-content div:nth-child(3) {
  left: 45px;
  animation-delay: 0s;
}
@media only screen and (max-device-width: 768px) {
  .topic-card {
    width: 100%;
    margin: 0;
  }
  .topic-card + .topic-card {
    margin-left: 0;
    margin-top: 10px;
  }

  .topic-card-container {
    margin-left: 0;
  }
}
@keyframes loading-content {
  0% {
    top: 6px;
    height: 51px;
  }
  50%,
  100% {
    top: 19px;
    height: 26px;
  }
}
</style>
